<template>
  <div class="informational-banner bright-blue hidden-print">
    <i
      id="dismiss-survey-banner"
      class="hi hi-close hi-10"
      @click="handleClose"
    />

    <div class="wrapper">
      <div class="content">
        <h4 class="title">
          Help shape the future of Insights
        </h4>

        <span class="description">
          Take our 5-minute survey — the first 100 participants get a $20 reward.
        </span>

        <div class="ctas">
          <a
            :href="surveyUrl"
            class="btn btn-sm primary-cta"
            target="_blank"
            rel="noopener noreferrer"
            @click="trackBannerClick('take_survey')"
          >
            Take survey
          </a>

          <div class="dismiss">
            <AppCheckbox v-model="dontShowAgain"> Don't show this again </AppCheckbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { UserOrganizationsResource } from '~/resources';

const SURVEY_URL = 'https://form.typeform.com/to/SrbVObqW';

export default {
  name: 'InsightsSurveyBanner',
  props: {
    tab: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    dontShowAgain: false,
    surveyUrl: SURVEY_URL,
  }),
  computed: {
    ...mapGetters(['organizationId', 'userOrganizationId', 'surveyBannerDismiss']),
  },
  mounted() {
    window.analytics?.track('Viewed Insights Survey Banner', {
      organization_id: this.organizationId,
      tab: this.tab,
    });
  },
  methods: {
    async handleClose() {
      this.trackBannerClick('close');

      if (this.dontShowAgain) {
        this.trackBannerClick('dont_show_again');
        await this.dismissBanner();
      }

      this.$emit('close');
    },
    async dismissBanner() {
      try {
        const response = await UserOrganizationsResource.dismissPromotion(
          { id: this.userOrganizationId },
          { dismiss: this.surveyBannerDismiss },
          { abortReload: true },
        );

        if (response?.errors) {
          this.$appMessage('Error dismissing banner.');
        }
      } catch (error) {
        if (![401, 403].includes(error?.status)) {
          this.$appMessage('Unexpected error. Please try again.');
        }
      }
    },
    trackBannerClick(ctaLabel) {
      window.analytics?.track('Clicked Insights Survey Banner', {
        cta_label: ctaLabel,
        organization_id: this.organizationId,
        tab: this.tab,
      });
    },
  },
};
</script>
